export function isEmptyObj(object: object | undefined) {
  let result = false;

  if (object) {
    const keys = Object.keys(object);
    const isKeys = keys?.length > 0;

    if (isKeys) {
      result = keys?.every(k => !object[k as keyof typeof object]);
    } else {
      result = true;
    }
  } else {
    result = true;
  }

  return result;
}
